import React from 'react';

import Belt from '../components/Belt';
import Footer from '../components/Footer';
import BeltLogged from '../components/BeltLogged';


class InfoPage extends React.Component {

  state = {
    data: [],
    newsCount: "",
    currentPage: "1"
  }

  async componentDidMount() {
    document.title = "Info - RezerwujKort.pl";
  }

  formatMessageWithNewLines = (text) => {
    return text.split("\n").map((line, index) => (
        <React.Fragment key={index}>
            {line}
            <br />
        </React.Fragment>
    ));
  };

  render() {

    var msg = this.props.location.state;
    var info = "";
    if (msg === undefined) {
      info = "";
    } else {
      info = <p> {this.formatMessageWithNewLines(msg)} </p>;
    }


    return (

      <div>

        <Belt />

        <BeltLogged />

        <div id="content">
          <div class="container">
            <div class="main-subpage-info">
              <p> {info} </p>
            </div>
          </div>
        </div>

        <Footer />

      </div>
    );
  }
}
export default InfoPage;
